import { render, staticRenderFns } from "./renshe.vue?vue&type=template&id=53dae354&scoped=true"
import script from "./renshe.vue?vue&type=script&lang=js"
export * from "./renshe.vue?vue&type=script&lang=js"
import style0 from "./renshe.vue?vue&type=style&index=0&id=53dae354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dae354",
  null
  
)

export default component.exports